/**
 * Minimal lead payloads used by mocked customer-profile flows.
 *
 * The overview endpoint intentionally returns a lightweight lead summary. The
 * customer page then hydrates that summary through the regular lead endpoint,
 * so this fixture contains the fields required by the Lead entity and note
 * composer.
 */
export const createTestActiveLead = (id: number) => ({
    id,
    account_id: 1,
    first_name: 'John',
    last_name: 'Doe',
    customer: { id: 1 },
    emails: [],
    phones: [],
});
